import React from 'react'

import { useLastActiveMediaTrayCard } from '../../../../firebase/hooks/useTray'
import { useRole } from '../../../../global/blocs/roomInfo'
import { OnDemandPlayback } from '../../../../headless/src/components/on-demand-playback/on-demand-playback'
import { posToStyle, useFeedPosition } from '../../../layouts'
import { FloorHeadlessFeed } from '../FloorHeadlessFeed/FloorHeadlessFeed'

import { FloorTrayImage } from './FloorTrayImage/FloorTrayImage'

const FloorTrayFeed = () => {
  const lastActiveMediaCard = useLastActiveMediaTrayCard()
  const role = useRole()
  const position = useFeedPosition('tray', 0)

  return (
    <div className="tray-track" style={posToStyle(position)}>
      {lastActiveMediaCard?.type === 'image' && (
        <FloorTrayImage trayCard={lastActiveMediaCard} />
      )}

      {role === 'headless' ? (
        <OnDemandPlayback isVisible={lastActiveMediaCard?.type === 'video'} />
      ) : (
        <FloorHeadlessFeed isVisible={lastActiveMediaCard?.type === 'video'} />
      )}
    </div>
  )
}

export { FloorTrayFeed }
